import { useRef, useEffect, useState } from 'react';

const MV_SCRIPT = 'https://ajax.googleapis.com/ajax/libs/model-viewer/3.5.0/model-viewer.min.js';

export default function HeroCanvas() {
  const containerRef = useRef();
  const [ready, setReady] = useState(false);

  // Step 1: Load the model-viewer library dynamically
  useEffect(() => {
    if (customElements.get('model-viewer')) {
      setReady(true);
      return;
    }

    const existing = document.querySelector(`script[src="${MV_SCRIPT}"]`);
    if (existing) {
      existing.addEventListener('load', () => setReady(true));
      return;
    }

    const script = document.createElement('script');
    script.type = 'module';
    script.src = MV_SCRIPT;
    script.onload = () => setReady(true);
    document.head.appendChild(script);
  }, []);

  // Step 2: Once library is loaded, create the <model-viewer> element
  useEffect(() => {
    if (!ready) return;
    const container = containerRef.current;
    if (!container) return;

    // Wait briefly for custom element to register after script load
    const timer = setTimeout(() => {
      const el = document.createElement('model-viewer');
      el.setAttribute('src', '/models/pontiac.glb');
      el.setAttribute('alt', 'Interactive 3D 1958 Pontiac Bonneville — Super Muffler Santa Maria');
      el.setAttribute('auto-rotate', '');
      el.setAttribute('auto-rotate-delay', '0');
      el.setAttribute('rotation-per-second', '30deg');
      el.setAttribute('camera-controls', '');
      el.setAttribute('touch-action', 'pan-y');
      el.setAttribute('shadow-intensity', '1.5');
      el.setAttribute('exposure', '1');
      el.setAttribute('environment-image', 'neutral');
      el.setAttribute('loading', 'eager');
      el.setAttribute('data-testid', 'hero-3d-model');
      el.style.width = '100%';
      el.style.height = '100%';
      el.style.background = 'transparent';
      el.style.borderRadius = '16px';

      container.appendChild(el);
    }, 300);

    return () => {
      clearTimeout(timer);
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
    };
  }, [ready]);

  return (
    <div
      ref={containerRef}
      className="hero-3d-wrapper"
      data-testid="hero-3d-wrapper"
    />
  );
}
